import { frontendURL } from 'dashboard/helper/URLHelper';
import { AI_ROUTES } from './constants';

const AiIntelligenceRouteView = () =>
  import('./pages/AiIntelligenceRouteView.vue');
const Overview = () => import('./pages/Overview.vue');
const SalesPerformance = () => import('./pages/SalesPerformance.vue');
const ClientIntelligence = () => import('./pages/ClientIntelligence.vue');
const ProductIntelligence = () => import('./pages/ProductIntelligence.vue');
const OpportunityCenter = () => import('./pages/OpportunityCenter.vue');
const OpportunityActionDemo = () => import('./pages/OpportunityActionDemo.vue');
const Targets = () => import('./pages/Targets.vue');

// AI Intelligence surfaces read/scoped data from Commercial Intelligence. Data
// authorization (admin vs salesperson) is enforced server-side by CI keyed on the
// agent's email, so the routes stay visible to any signed-in account member; an
// unmapped agent simply sees the section's error/empty state.
const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai-intelligence'),
      component: AiIntelligenceRouteView,
      children: [
        {
          path: '',
          name: AI_ROUTES.index,
          redirect: to => ({ name: AI_ROUTES.overview, params: to.params }),
        },
        {
          path: 'overview',
          name: AI_ROUTES.overview,
          meta,
          component: Overview,
        },
        {
          path: 'sales-performance',
          name: AI_ROUTES.salesPerformance,
          meta,
          component: SalesPerformance,
        },
        {
          path: 'clients',
          name: AI_ROUTES.clients,
          meta,
          component: ClientIntelligence,
        },
        {
          path: 'products',
          name: AI_ROUTES.products,
          meta,
          component: ProductIntelligence,
        },
        {
          path: 'opportunities',
          name: AI_ROUTES.opportunities,
          meta,
          component: OpportunityCenter,
        },
        {
          path: 'action-demo',
          name: AI_ROUTES.actionDemo,
          meta,
          component: OpportunityActionDemo,
        },
        { path: 'targets', name: AI_ROUTES.targets, meta, component: Targets },
      ],
    },
  ],
};
